module.exports = __webpack_public_path__ + "img/design10.0f086b9e.png";